import CustomForm from '../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../application/config/config';
import Fetch from '../../../util/core/Fetch';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';


function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const dispatch = useDispatch();
    const session = useSelector((state) => { return state.core.session.userSession });
    const id = session.user.id;
    let labelTitle = 'Meus dados';
    const endpointBackend = config.endpoints.backend;

    const path = '/core/users/';
    const paths = {
        endpointSave: endpointBackend + 'core/users/save',
        endpointGetById: endpointBackend + 'core/users/getById',
        urlGoBack: path + 'list',
        endpointGetByReference: endpointBackend + 'core/configs/getByReference',
    }

    const getForm = () => {
        let form = {
            labelTitle: labelTitle,
            labelSubmitButton: 'Salvar',
            validateOnChange: true,
            showGoBackButton: false,
            id: id,
            afterSubmit: (form, values) => {
                let userSession = { ...session, ...{} };
                userSession.user.name = values.name;
                userSession.user.photo = values.photo;
                userSession.user.mobile_phone = values.mobile_phone;
                userSession.user.email = values.email;
                userSession.user.login = values.login;
                dispatch({ type: 'UPDATE_SESSION', key: 'userSession', value: userSession });
            },
            fields: [
                {
                    name: 'photo',
                    type: 'fileS3',
                    crop: true,
                    label: 'Foto',
                    uploadPath: '/users/photos/',
                    extensionAccept: '.jpeg,.jpg,.png',
                    limitFileSize: 5,
                    validations: {
                    },
                    columnSize: 12
                },
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'email',
                    type: 'email',
                    label: 'Email',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'mobile_phone',
                    type: 'phone',
                    label: 'Celular',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    type: 'label',
                    label: '',
                    columnSize: 12
                },
                {
                    name: 'login',
                    type: 'text',
                    label: 'Login',
                    validations: {
                        required: true,
                        login: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password',
                    type: 'password',
                    label: 'Senha',
                    validations: {
                        password: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password_confirm',
                    type: 'password',
                    label: 'Repetir senha',
                    validations: {
                        password_confirm: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                login: async (value, options, key, attributes) => {
                    const checkLogin = async (value) => {
                        let post = { login: value };
                        post.user_id = id;
                        if (value.trim().length > 2) {
                            let response = await Fetch.post(endpointBackend + 'core/users/getbylogin', post);
                            if (response.length > 0) {
                                return '^O login já está sendo utilizado por outro usuário';
                            }
                        }

                        return "";
                    }
                    return checkLogin(value);
                },
                password_confirm: (value, options, key, attributes) => {
                    if (value !== attributes.password_confirm) {
                        return '^O campo repetir senha deve ter igual ao campo senha';
                    } else {
                        return '';
                    }
                }
            },
            ...paths
        }
        return form;
    }

    useEffect(() => {
        const load = async () => {
            const form = getForm();
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={{ ...form, ...paths }} />} />
            );
        }
        load();
    }, []);

    useEffect(() => {
        if (session.user.is_first_access === '0') return;

        const setFirstAccess = async () => {
            const endpoint = config.endpoints.backend + 'core/users/updateFirstAccess';
            const body = { id: session.user.id, is_first_access: '0' };

            await Fetch.put(endpoint, body);
        };

        setFirstAccess();
    }, []);

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
